"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompetencyLevelSchema () {
        return CompetencyLevelSchema;
    },
    get CompetencyRatingScaleOptionSchema () {
        return CompetencyRatingScaleOptionSchema;
    },
    get CompetencyRatingScaleSchema () {
        return CompetencyRatingScaleSchema;
    },
    get CompetencySchema () {
        return CompetencySchema;
    },
    get CompetencyStatusSchema () {
        return CompetencyStatusSchema;
    }
});
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const _constants = require("./constants");
const CompetencyStatusSchema = _zod.z.enum([
    "active",
    "archived"
]).default("active");
const CompetencyLevelSchema = _zod.z.object({
    rank: _zod.z.number().int().min(1).max(_constants.MAX_COMPETENCY_LEVELS),
    name: _zod.z.string(),
    description: _zod.z.string().default("")
});
const CompetencyRatingScaleOptionSchema = _zod.z.object({
    value: _zod.z.number(),
    label: _zod.z.string()
});
const CompetencyRatingScaleSchema = _zod.z.object({
    options: _zod.z.array(CompetencyRatingScaleOptionSchema).min(1)
});
const CompetencySchema = _base.BaseDocument.extend({
    name: _zod.z.string(),
    description: _zod.z.string().default(""),
    is_company_wide: _zod.z.boolean().default(false),
    status: CompetencyStatusSchema,
    levels: _zod.z.array(CompetencyLevelSchema).min(1).max(_constants.MAX_COMPETENCY_LEVELS).default([]),
    rating_scale: CompetencyRatingScaleSchema.nullable().default(null),
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord
});
